import { createContext } from 'react';

/**
 * @public
 */
var MotionConfigContext = createContext({
    transformPagePoint: function (p) { return p; },
    isStatic: false,
    reducedMotion: "never",
});

export { MotionConfigContext };



//////////////////
// WEBPACK FOOTER
// ./node_modules/framer-motion/dist/es/context/MotionConfigContext.mjs
// module id = llKo
// module chunks = 0